import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/user/settings')({
	component: UserSettingsPage,
});

function UserSettingsPage() {
	return <div />;
}
